import React from "react";
import Link from "../global/Link";

export const FooterLineMenu = ({menu}) => {
  const cssClass = "d-inline-flex align-items-center subtitle-md me-6";

  return menu?.length > 0 && menu.map((item, index) => (
      <React.Fragment key={index}>
        {item.target === '_blank' ?
          <a className={cssClass} href={item.url} target="_blank" rel="noreferrer noopener">
            <svg className="me-2" width={16} height={16}><use xlinkHref="#icon-external"/></svg>{item.label}
          </a>
          :
          <Link className={cssClass} to={item.url}>{item.label}</Link>
        }
      </React.Fragment>
    )
  )
}
